var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BriqButton',_vm._g({class:_vm.extraClasses,attrs:{"wide":""}},_vm.$listeners),[(this.pending)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.activeLabel)}}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }